module.exports = __webpack_public_path__ + "static/media/validate@2x.5810ebc5.png";